import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { imageUrl } from '../lib/images'
import { getLanguageFromPath } from '../i18n/routes'

const FOOTER_TEXTS = {
  da: {
    infoTitle: 'Informationer',
    contactPerson: 'c/o Karina Ella Escherich',
    phoneLabel: 'Tlf:',
    emailLabel: 'Email:',
    cvrLabel: 'CVR-nr: 42370509',
    hoursTitle: 'Åbningstider',
    days: [
      { day: 'Mandag', hours: '10:00 – 17:00' },
      { day: 'Tirsdag', hours: '10:00 – 17:00' },
      { day: 'Onsdag', hours: '10:00 – 17:00' },
      { day: 'Torsdag', hours: '10:00 – 17:00' },
      { day: 'Fredag', hours: '10:00 – 17:00' },
      { day: 'Lørdag', hours: '10:00 – 17:00' },
      { day: 'Søndag', hours: 'Lukket' },
    ],
    overviewTitle: 'Overblik',
    links: {
      contact: { label: 'Kontakt & Find vej', url: '/aabningstider-og-adresse' },
      terms: { label: 'Betingelser', url: '/betingelser' },
      lag: { label: 'LAG Understøttelse', url: '/om-mig#projektstoette' },
      shop: { label: 'Webshop', url: '/webshop' },
      retailers: { label: 'Forhandlerliste', url: '/forhandlerliste' },
      inquiry: { label: 'Kageforespørgsel', url: '/forspoergsel' },
    },
    newsletterTitle: 'Tilmeld dig nyhedsbrevet',
    newsletterDesc:
      'Tilmeld dig mit nyhedsbrev og få søde nyheder, særlige tilbud og små glimt fra livet hos Fanø Chokolade – direkte i din indbakke',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    email: 'E-mail',
    subscribeBtn: 'Abonner',
    subscribingBtn: 'Tilmelder...',
    successTitle: 'Tak for tilmeldingen!',
    successDesc: 'Du er nu tilmeldt Fanø Chokolades nyhedsbrev.',
    fillError: 'Udfyld venligst fornavn, efternavn og e-mail.',
    genericError: 'Kunne ikke tilmelde nyhedsbrevet. Prøv igen.',
    rights: 'Alle rettigheder forbeholdes.',
    smileyTitle: 'Se Fødevarestyrelsens kontrolrapport',
    lagTitle: 'Læs om LAG Understøttelse',
  },
  en: {
    infoTitle: 'Information',
    contactPerson: 'c/o Karina Ella Escherich',
    phoneLabel: 'Phone:',
    emailLabel: 'Email:',
    cvrLabel: 'VAT/CVR: DK42370509',
    hoursTitle: 'Opening Hours',
    days: [
      { day: 'Monday', hours: '10:00 – 17:00' },
      { day: 'Tuesday', hours: '10:00 – 17:00' },
      { day: 'Wednesday', hours: '10:00 – 17:00' },
      { day: 'Thursday', hours: '10:00 – 17:00' },
      { day: 'Friday', hours: '10:00 – 17:00' },
      { day: 'Saturday', hours: '10:00 – 17:00' },
      { day: 'Sunday', hours: 'Closed' },
    ],
    overviewTitle: 'Explore',
    links: {
      contact: { label: 'Contact & Directions', url: '/en/opening-hours-and-location' },
      terms: { label: 'Terms & Conditions', url: '/en/terms' },
      lag: { label: 'EU LAG Support', url: '/en/eu-lag-support' },
      shop: { label: 'Online Shop', url: '/en/shop' },
      retailers: { label: 'Retailers & Stockists', url: '/en/retailers' },
      inquiry: { label: 'Custom Cake Inquiry', url: '/en/cake-inquiry' },
    },
    newsletterTitle: 'Subscribe to our newsletter',
    newsletterDesc:
      'Subscribe to receive sweet news, seasonal artisan creations, special offers, and stories from Fanø Chokolade directly to your inbox 🍫',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    subscribeBtn: 'Subscribe',
    subscribingBtn: 'Subscribing...',
    successTitle: 'Thank you for subscribing!',
    successDesc: 'You are now subscribed to the Fanø Chokolade newsletter.',
    fillError: 'Please enter your first name, last name and email.',
    genericError: 'Could not subscribe to newsletter. Please try again.',
    rights: 'All rights reserved.',
    smileyTitle: 'View Danish Food Authority inspection report',
    lagTitle: 'Learn about EU LAG Support',
  },
  de: {
    infoTitle: 'Informationen',
    contactPerson: 'c/o Karina Ella Escherich',
    phoneLabel: 'Tel:',
    emailLabel: 'Email:',
    cvrLabel: 'USt-IdNr./CVR: DK42370509',
    hoursTitle: 'Öffnungszeiten',
    days: [
      { day: 'Montag', hours: '10:00 – 17:00' },
      { day: 'Dienstag', hours: '10:00 – 17:00' },
      { day: 'Mittwoch', hours: '10:00 – 17:00' },
      { day: 'Donnerstag', hours: '10:00 – 17:00' },
      { day: 'Freitag', hours: '10:00 – 17:00' },
      { day: 'Samstag', hours: '10:00 – 17:00' },
      { day: 'Sonntag', hours: 'Geschlossen' },
    ],
    overviewTitle: 'Übersicht',
    links: {
      contact: { label: 'Kontakt & Anfahrt', url: '/de/oeffnungszeiten-und-adresse' },
      terms: { label: 'AGB & Datenschutz', url: '/de/agb' },
      lag: { label: 'EU-LAG Förderung', url: '/de/eu-lag-foerderung' },
      shop: { label: 'Onlineshop', url: '/de/shop' },
      retailers: { label: 'Händlerliste', url: '/de/haendler' },
      inquiry: { label: 'Tortenanfrage', url: '/de/tortenanfrage' },
    },
    newsletterTitle: 'Newsletter abonnieren',
    newsletterDesc:
      'Melden Sie sich für unseren Newsletter an und erhalten Sie süße Neuigkeiten, Angebote und Einblicke direkt aus der Schokoladenmanufaktur auf Fanø 🍫',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    subscribeBtn: 'Abonnieren',
    subscribingBtn: 'Wird angemeldet...',
    successTitle: 'Vielen Dank für Ihre Anmeldung!',
    successDesc: 'Sie haben den Newsletter von Fanø Chokolade erfolgreich abonniert.',
    fillError: 'Bitte füllen Sie Vorname, Nachname und E-Mail-Adresse aus.',
    genericError: 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    rights: 'Alle Rechte vorbehalten.',
    smileyTitle: 'Kontrollbericht der dänischen Lebensmittelbehörde ansehen',
    lagTitle: 'Mehr über die EU-LAG-Förderung erfahren',
  },
}

export default function Footer() {
  const location = useLocation()
  const currentLang = getLanguageFromPath(location.pathname)
  const t = FOOTER_TEXTS[currentLang] || FOOTER_TEXTS.da
  const country = { da: 'Danmark', en: 'Denmark', de: 'Dänemark' }[currentLang]
  const followLabel = { da: 'Følg Fanø Chokolade på', en: 'Follow Fanø Chokolade on', de: 'Fanø Chokolade folgen auf' }[currentLang]

  const [formData, setFormData] = useState({
    fornavn: '',
    efternavn: '',
    email: '',
    website_url: '', // Honeypot
  })
  const [status, setStatus] = useState('idle') // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (formData.website_url) {
      setStatus('success')
      return
    }

    if (!formData.fornavn || !formData.efternavn || !formData.email) {
      setErrorMessage(t.fillError)
      setStatus('error')
      return
    }

    try {
      setStatus('loading')
      setErrorMessage('')

      const res = await fetch('/_api/webform/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form_name: `Nyhedsbrev tilmelding (${currentLang.toUpperCase()})`,
          fornavn: formData.fornavn,
          efternavn: formData.efternavn,
          email: formData.email,
          website_url: formData.website_url,
        }),
      })

      if (!res.ok) {
        throw new Error(t.genericError)
      }

      setStatus('success')
      setFormData({
        fornavn: '',
        efternavn: '',
        email: '',
        website_url: '',
      })
    } catch (err) {
      setStatus('error')
      setErrorMessage(err.message || t.genericError)
    }
  }

  return (
    <footer className="relative bg-[#C68D94] text-white pt-16 pb-12 overflow-hidden mt-16">
      {/* Broad Cupcake Wavy / Scalloped Shape Divider */}
      <div className="absolute top-0 left-0 right-0 w-full overflow-hidden leading-none pointer-events-none transform -translate-y-[99%]">
        <svg
          viewBox="0 0 1440 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-12 sm:h-16 md:h-20 text-[#C68D94] preserve-3d"
          preserveAspectRatio="none"
        >
          <path
            d="M 0,48 C 55,10 185,10 240,48 C 295,10 425,10 480,48 C 535,10 665,10 720,48 C 775,10 905,10 960,48 C 1015,10 1145,10 1200,48 C 1255,10 1385,10 1440,48 L 1440,80 L 0,80 Z"
            fill="currentColor"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main 3-Column Info Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12 pb-14 border-b border-white/20">
          {/* Col 1: Informationer */}
          <div>
            <img
              src={imageUrl('https://assets.auxodev.dk/assets/794f847f-602c-4879-a337-d3ce1466cad5/fanoe-chokolade-logo-lockup-color-rgb.png', 'width=600,quality=80,format=auto')}
              alt="Fanø Chokolade"
              className="w-56 sm:w-64 max-[1199px]:w-40 sm:max-[1199px]:w-48 h-auto mb-6"
              loading="lazy"
            />
            <div className="text-xs sm:text-sm font-light space-y-1.5 text-white/95 leading-relaxed">
              <p>Strandvejen 58,</p>
              <p>6720 Fanø, {country}</p>
              <p className="pt-2">
                {t.phoneLabel}{' '}
                <a
                  href="tel:60224704"
                  className="font-medium hover:underline focus:outline-none focus:ring-1 focus:ring-white rounded whitespace-nowrap text-white"
                >
                  60 22 47 04
                </a>
              </p>
              <p>
                {t.emailLabel}{' '}
                <a
                  href="mailto:karina@fanoechokolade.dk"
                  className="font-medium hover:underline focus:outline-none focus:ring-1 focus:ring-white rounded whitespace-nowrap text-white"
                >
                  karina@fanoechokolade.dk
                </a>
              </p>
              <p className="pt-1 text-white/80">{t.cvrLabel}</p>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.facebook.com/Fanochokolade"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-white/80 flex items-center justify-center text-lg transition-colors focus:outline-none"
                aria-label={`${followLabel} Facebook`}
              >
                <i className="fa-brands fa-facebook-f" aria-hidden="true" />
              </a>
              <a
                href="https://www.instagram.com/fanoechokolade"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-white/80 flex items-center justify-center text-lg transition-colors focus:outline-none"
                aria-label={`${followLabel} Instagram`}
              >
                <i className="fa-brands fa-instagram" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Col 2: Åbningstider */}
          <div>
            <h3 className="font-script text-3xl sm:text-4xl font-normal mb-5 tracking-wide text-center md:text-left">
              {t.hoursTitle}
            </h3>
            <div className="overflow-hidden rounded-lg border border-white/30 text-xs sm:text-sm">
              <table className="w-full text-left">
                <tbody className="divide-y divide-white/20">
                  {t.days.map((item, idx) => (
                    <tr
                      key={idx}
                      className={
                        idx === t.days.length - 1
                          ? 'bg-white/10 font-medium'
                          : idx % 2 === 0
                          ? 'bg-white/5'
                          : ''
                      }
                    >
                      <td className="py-2 px-3 font-medium">{item.day}</td>
                      <td className="py-2 px-3 text-right">{item.hours}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Col 3: Overblik */}
          <div>
            <h3 className="font-script text-3xl sm:text-4xl font-normal mb-5 tracking-wide">
              {t.overviewTitle}
            </h3>
            <ul className="space-y-2.5 text-xs sm:text-sm font-light">
              <li>
                <Link
                  to={t.links.contact.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.contact.label}
                </Link>
              </li>
              <li>
                <Link
                  to={t.links.terms.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.terms.label}
                </Link>
              </li>
              <li>
                <Link
                  to={t.links.lag.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.lag.label}
                </Link>
              </li>
              <li>
                <Link
                  to={t.links.shop.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.shop.label}
                </Link>
              </li>
              <li>
                <Link
                  to={t.links.retailers.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.retailers.label}
                </Link>
              </li>
              <li>
                <Link
                  to={t.links.inquiry.url}
                  className="hover:underline text-white/95 hover:text-white transition-colors"
                >
                  {t.links.inquiry.label}
                </Link>
              </li>
            </ul>

            {/* LAG Understøttelse Badge */}
            <div className="mt-6">
              <Link
                to={t.links.lag.url}
                className="inline-block"
                title={t.lagTitle}
              >
                <img
                  src={imageUrl('/_assets/blaa-tekst-vertikal-medfinansieret.png', 'width=300,quality=90,format=auto')}
                  alt="Den Europæiske Landbrugsfond - LAG medfinansieret"
                  className="h-24 sm:h-28 w-auto object-contain"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* Lower Newsletter Section */}
        <div className="pt-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          <div>
            <h4 className="text-xl sm:text-2xl font-normal text-white mb-2">
              {t.newsletterTitle}
            </h4>
            <p className="text-xs sm:text-sm font-light text-white/90 leading-relaxed max-w-md">
              {t.newsletterDesc}
            </p>
          </div>

          <div>
            {status === 'success' ? (
              <div className="bg-white/20 border border-white/40 rounded-xl p-6 text-center text-white">
                <i className="fa-solid fa-circle-check text-2xl mb-2 text-white" aria-hidden="true" />
                <h5 className="font-semibold text-base">{t.successTitle}</h5>
                <p className="text-xs text-white/90 mt-1">
                  {t.successDesc}
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-3">
                {/* Antispam honeypot */}
                <input
                  type="text"
                  name="website_url"
                  value={formData.website_url}
                  onChange={handleInputChange}
                  className="sr-only absolute -left-[9999px]"
                  tabIndex={-1}
                  autoComplete="off"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label htmlFor={`footer-fornavn-${currentLang}`} className="sr-only">
                      {t.firstName}
                    </label>
                    <input
                      id={`footer-fornavn-${currentLang}`}
                      type="text"
                      name="fornavn"
                      value={formData.fornavn}
                      onChange={handleInputChange}
                      placeholder={t.firstName}
                      required
                      className="w-full bg-white text-[#3E3435] text-xs px-3.5 py-2.5 rounded-lg placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-white"
                    />
                  </div>
                  <div>
                    <label htmlFor={`footer-efternavn-${currentLang}`} className="sr-only">
                      {t.lastName}
                    </label>
                    <input
                      id={`footer-efternavn-${currentLang}`}
                      type="text"
                      name="efternavn"
                      value={formData.efternavn}
                      onChange={handleInputChange}
                      placeholder={t.lastName}
                      required
                      className="w-full bg-white text-[#3E3435] text-xs px-3.5 py-2.5 rounded-lg placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-white"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor={`footer-email-${currentLang}`} className="sr-only">
                    {t.email}
                  </label>
                  <input
                    id={`footer-email-${currentLang}`}
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder={t.email}
                    required
                    className="w-full bg-white text-[#3E3435] text-xs px-3.5 py-2.5 rounded-lg placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-white"
                  />
                </div>

                {errorMessage && (
                  <p className="text-xs bg-red-900/40 text-red-100 p-2 rounded border border-red-300/30">
                    {errorMessage}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full border border-white text-white hover:bg-white hover:text-[#A35D67] text-xs font-semibold py-2.5 px-6 rounded-lg uppercase tracking-wider transition-colors disabled:opacity-50 cursor-pointer"
                >
                  {status === 'loading' ? t.subscribingBtn : t.subscribeBtn}
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Copyright notice */}
        <div className="mt-12 pt-6 border-t border-white/20 text-center text-xs text-white/70">
          <p>© {new Date().getFullYear()} Fanø Chokolade. {t.rights}</p>
        </div>
      </div>
    </footer>
  )
}
